module.exports = __webpack_public_path__ + "img/5.21ae4504.png";